const FIRST_NAMES = ['Ana', 'Bruno', 'Carla', 'Daniel', 'Eduarda', 'Felipe']
const LAST_NAMES = ['Silva', 'Santos', 'Oliveira', 'Souza', 'Pereira']
const WORDS = ['lorem', 'ipsum', 'dev', 'api', 'teste', 'dado', 'sistema']

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min
const randomFrom = (list) => list[randomInt(0, list.length - 1)]

export const FIELD_TYPES = [
  { key: 'uuid', label: 'UUID' },
  { key: 'name', label: 'Nome' },
  { key: 'email', label: 'E-mail' },
  { key: 'number', label: 'Número' },
  { key: 'boolean', label: 'Booleano' },
  { key: 'date', label: 'Data (ISO)' },
  { key: 'word', label: 'Palavra' },
  { key: 'sentence', label: 'Frase' },
]

const generateUuid = () =>
  window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now()}-${randomInt(1000, 9999)}`

const generateValue = (type) => {
  switch (type) {
    case 'uuid':
      return generateUuid()
    case 'name': {
      const first = randomFrom(FIRST_NAMES)
      const last = randomFrom(LAST_NAMES)
      return `${first} ${last}`
    }
    case 'email':
      return `${randomFrom(FIRST_NAMES).toLowerCase()}${randomInt(1, 99)}@exemplo.com`
    case 'number':
      return randomInt(1, 1000)
    case 'boolean':
      return Math.random() < 0.5
    case 'date':
      return new Date(
        Date.now() - randomInt(0, 365) * 24 * 60 * 60 * 1000,
      ).toISOString()
    case 'word':
      return randomFrom(WORDS)
    case 'sentence':
      return Array.from({ length: randomInt(4, 9) }, () => randomFrom(WORDS)).join(' ')
    default:
      return null
  }
}

export const generateMockRecords = (fields, count) =>
  Array.from({ length: count }, () => {
    const record = {}
    fields.forEach((field) => {
      if (field.name.trim()) record[field.name.trim()] = generateValue(field.type)
    })
    return record
  })
